import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PageTransition wrapper
 * Smooth, lightweight 200ms enter animation and auto scroll-to-top on route navigation.
 */
export const PageTransition = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname, location.search]);

  return (
    <div key={location.pathname} className="animate-page-enter will-change-transform">
      {children}
    </div>
  );
};

export default PageTransition;
